import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ApiPartnerService } from "@app/api/api-partner.service";
import { interval } from "rxjs";
import swal from "sweetalert/dist/sweetalert.min.js";

@Component({
  selector: "app-master-package",
  templateUrl: "./master-package.component.html",
  styleUrls: ["./master-package.component.css"],
})
export class MasterPackageComponent implements OnInit {
  @ViewChild("closeBtn", { static: false }) closeBtn: ElementRef;

  listPackages: any = [];
  listMasterApps: any = [];
  listMasterThemes: any = [];
  table_load = true;
  paging: any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index: number;
  first_index: number;
  total_count: number;
  querySearch = false;
  searching = false;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";
  limit = 10;
  msearch: string;
  textSearch = new FormControl("");
  alert_act: any = [];
  formSet = this.fb.group({
    partnerId: [""],
    packageName: [""],
    packageCode: [""],
    apps: [""],
    selectedTheme: [""],
    flagActive: [""],
  });
  falsemessage: string;
  message: string;
  itemset: any = {};
  selectedApps: any = [];
  selectedTheme: any;
  data_partner: any = [];

  constructor(
    public partnerService: ApiPartnerService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.loadStart();
  }

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  loadStart() {
    this.route.queryParams.subscribe((params) => {
      if (params.search != "" && params.search != undefined) {
        this.msearch = params.search;
        this.querySearch = true;

        this.currentParams = params;
        this.queryParams = "?" + this.queryStr(params);
        this.loadPackages(this.queryParams);
      } else {
        this.querySearch = false;
        this.currentParams = params;

        this.queryParams = "?" + this.queryStr(params);
        this.loadPackages(this.queryParams);
      }
    });
    this.msearch = undefined;
  }

  refreshPage() {
    this.ngOnInit();
  }

  search() {
    this.querySearch = true;

    if (this.msearch == undefined) {
      this.msearch = "";
    }
    if (this.limit != undefined) {
      this.searchQueryParams =
        "?page=" + this.page_self["page"] + "&search=" + this.msearch;
    }
    this.loadPackages(this.searchQueryParams);
  }

  onActionClick(act: any, item: any) {
    this.alert_act = act;

    if (this.alert_act == "add") {
      this.clearForm();
      this.loadMasterApp();
      this.getPartner();
      this.loadMasterTheme();
    }
    if (this.alert_act == "view") {
      this.itemset = item;
      this.loadPackageDetail(this.itemset.id);
    }
  }

  clearForm() {
    this.formSet.reset();
    this.formSet.get("packageName").setValue(undefined);
    this.formSet.get("packageCode").setValue(undefined);
  }

  getPartner() {
    this.partnerService.GetViewnextsyspartnerless().subscribe((output: any) => {
      this.data_partner = output.data;
    });
  }

  loadPackages(params: any) {
    this.table_load = true;

    return this.partnerService.GetPackages(params).subscribe((output: any) => {
      this.listPackages = output.data;
      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta["totalCount"];
      let self = this.page_self["page"];
      if (self * this.meta["perPage"] < this.meta["totalCount"]) {
        this.last_index = self * this.meta["perPage"];
      } else {
        this.last_index = this.meta["totalCount"];
      }
      this.first_index = (self - 1) * this.meta["perPage"] + 1;
    });
  }

  loadMasterApp() {
    this.selectedApps = [];
    let params = "?limit=1000&flagActive=1";
    this.partnerService.GetApps(params).subscribe((output: any) => {
      this.listMasterApps = output.data;

      // App Vision+ autoselected
      if (output.data.length > 0) {
        output.data.forEach((element) => {
          if (element.name === "Vision+") {
            this.selectedApps.push(element.id);
          }
        });
      }
    });
  }

  loadMasterTheme() {
    this.listMasterThemes = [];
    let params = "?limit=1000&flagActive=1";
    this.partnerService.GetThemes(params).subscribe((output: any) => {
      this.listMasterThemes = output.data;
    });
  }

  loadPackageDetail(id: any) {
    this.loadMasterApp();
    this.getPartner();
    this.loadMasterTheme();
    this.partnerService.GetPackageDetail(id).subscribe((output: any) => {
      this.selectedApps = [];
      let data = output.data;
      this.itemset = data;
      this.formSet.get("partnerId").setValue(data.id_partner);
      this.formSet.get("packageName").setValue(data.name);
      this.formSet.get("packageCode").setValue(data.code);
      this.formSet.get("flagActive").setValue(data.flag_active.toString());
      data.apps.forEach((app) => {
        this.selectedApps.push(app.id);
      });
      this.formSet.get("selectedTheme").setValue(data.theme.id);
      this.selectedTheme = data.theme.id;
    });
  }

  onAppSelect(app, event) {
    if (event.target.checked) {
      // if (this.selectedApps.length < 3) {
      this.selectedApps.push(app.id);
      // } else {
      // event.target.checked = false; // Limit reached
      // }
    } else {
      this.selectedApps = this.selectedApps.filter(
        (selected) => selected !== app.id
      );
    }
  }

  onSelectTheme(event: any) {
    this.selectedTheme = event.target.value;
    console.log("Selected theme ID:", this.selectedTheme);
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

  alertsx(message: any) {
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(() => {
      this.closeModal();
      this.ngOnInit();
    }, 1000);
  }
  alertfx(message: any) {
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
  }

  submitAdd() {
    let details = [];

    this.selectedApps.forEach((element) => {
      details.push({ id_cgmn_app: element, id_cgmn_theme: this.selectedTheme });
    });
    let postData = {
      name: this.formSet.get("packageName").value,
      code: this.formSet.get("packageCode").value,
      partnerId: this.formSet.get("partnerId").value,
      details: details,
    };

    this.partnerService.CreatePackage(postData).subscribe((output: any) => {
      if (output) {
        if (output.status == true) {
          this.message = output.message;
          this.alertsx(this.message);
          this.clearForm();
        } else {
          this.falsemessage = this.falsemessage;
          this.message = output.message;
          this.alertfx(this.message);
        }
      } else {
        this.alertfx("Error hit API");
      }
    });
  }

  submitSet() {
    let id = this.itemset.id;

    let details = [];

    this.selectedApps.forEach((element) => {
      details.push({ id_cgmn_app: element, id_cgmn_theme: this.selectedTheme });
    });

    let putData = {
      name: this.formSet.get("packageName").value,
      code: this.formSet.get("packageCode").value,
      partnerId: this.formSet.get("partnerId").value,
      details: details,
      flag_active: parseInt(this.formSet.get("flagActive").value),
    };

    this.partnerService.UpdatePackage(id, putData).subscribe((output: any) => {
      if (output.status == true) {
        this.message = output.message;
        this.alertsx(this.message);
      } else {
        this.message = output.message;
        this.alertfx(this.message);
      }
    });
  }

  submitDelete() {
    let id = this.itemset.id;
    swal({
      title: "Are you sure?",
      text: '"' + this.itemset.name + '" Akan dihapus',
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.partnerService.DeletePackage(id).subscribe((output: any) => {
          if (output.status == true) {
            this.message = output.message;
            this.alertsx(this.message);
          } else {
            this.message = output.message;
            this.alertfx(this.message);
          }
        });
      }
    });
  }
}
